<template>
	<BaseCmsPage v-slot="{page}">
	<Body class="page-catalog-view_wishlist" />
		<ClientOnly>
            <BaseCatalogWishlist v-slot="{items,  onRemove}" @loadProductsWidget="onLoadedProducts">
                <div class="intro-container wishlist-intro-container">
                    <div class="wider-wrapper">
                        <div class="intro-container-inner">
                            <div class="wishlist-header">
                                <h1 class="wishlist-title"><BaseCmsLabel code="my_wishlist" /> <span v-if="items?.length > 0" class="a-wishlist-counter active">(<span class="wishlist_count">{{items?.length}}</span>)</span></h1>

                                <div v-if="items?.length > 0" @click="onRemove" class="wishlist-btn-delete">
                                    <span><BaseCmsLabel code="delete_wishlist" /></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="wishlist-section">
                    <div class="wider-wrapper">            
                        <div v-if="items?.length > 0" class="wishlist-detail-items">
                            <template v-for="item in items" :key="item.id">
                                <CatalogIndexEntry :item="item" mode="wishlist" />
                            </template>                            
                        </div>
                        <div v-else class="wishlist-empty">
                            <BaseCmsLabel code="wishlist_no_products" />
                        </div>
                    </div>
                </div>
            </BaseCatalogWishlist>
		</ClientOnly>
	</BaseCmsPage>
</template>

<script setup>
	const auth = useAuth();
	const labels = useLabels();
	const {getAppUrl} = useApiRoutes();
	const isLoggedIn = computed(() => auth.isLoggedIn());

	onMounted(() => {
		if(isLoggedIn.value) {
			navigateTo({path: getAppUrl('auth_wishlist')})
		}
	})

	function onLoadedProducts(products){
		if(products?.items.length){
			sendProductImpressions(products.items, "wishlist");
		}
	}
</script>